import { Box, Menu, MenuList, MenuOptionGroup } from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { trackSelectDelineation } from '../../analytics/thunks/track-select-delineation.thunk';
import {
  delineationsSelector,
  selectedDelineationSelector,
} from '../selectors/delineation.selectors';
import { pickDelineation } from '../thunks/pick-delineation.thunk';
import { CustomMenuItemOption } from '../../../shared/components/dropdown/CustomMenuItemOption';
import { CustomMenuButton } from '../../../shared/components/dropdown/CustomMenuButton';

export const DelineationPicker: React.FC = () => {
  const dispatch = useDispatch();
  const delineations = useSelector(delineationsSelector);
  const delineation = useSelector(selectedDelineationSelector);

  if (delineations.length === 0 || delineation == null) {
    return <></>;
  }

  const handleClick = (delineationId: number) => {
    if (delineationId) {
      dispatch(trackSelectDelineation(delineationId));
      dispatch(pickDelineation(delineationId));
    }
  };

  return (
    <Box>
      <Menu matchWidth>
        <CustomMenuButton
          expertName={delineation.expertName}
          updatedAt={delineation.updatedAt}
          immutable={delineation.immutable}
          data-testid='delineation-dropdown'
        />
        <MenuList maxWidth='unset'>
          <MenuOptionGroup
            type='radio'
            onChange={(v) => handleClick(parseInt(v as string))}
            value={`${delineation.id}`}
          >
            {delineations.map(({ expertName, id, immutable, updatedAt }) => (
              <CustomMenuItemOption
                expertName={expertName}
                updatedAt={updatedAt}
                immutable={immutable}
                key={id}
                value={`${id}`}
              />
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};
